<div id="accessMethodCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@accessMethod_title">Metodi d'accesso</ng-container>
    <fa-icon *ngIf="canUserEdit" icon="edit" class="float-right margin-right-20 icon-clickable" (click)="modifyAccessMethods()"></fa-icon>
  </div>

  <div class="control-card-content">

    <div class="table-container">

      <table mat-table matSort #accessmethodtable [dataSource]="dataSource" class="simple-table">

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef i18n="@@accessMethod_type">Tipo</th>
          <td mat-cell *matCellDef="let element">
            <fa-icon *ngIf="element.type == phoneType || element.type == carType || element.type == appType|| element.type == pinCodeType|| element.type == badgeType" icon={{selectIcon(element.type)}} class="fa-lg" style="width: 25px; float : left; margin-right: 10px;" (click)="modifyAccessMethods()">
            </fa-icon>
            <img *ngIf="element.type == remote1cType" style="float : left; margin-right: 10px;" class="customIcon" src="/assets/icons/why.svg" />
            <img *ngIf="element.type == remoteType" style="float : left; margin-right: 10px;" class="customIcon" src="/assets/icons/jcm.svg" />

            <p style="margin-left: 40px;">{{getAccessMethodType(element.type)}}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef i18n="@@accessMethod_code">Codice</th>
          <td mat-cell *matCellDef="let element"> {{ element.code }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.mat-cell-selected]="selectedRow == row.id">
        </tr>

      </table>

    </div>

  </div>

  <app-loading-screen #accessmethodloader></app-loading-screen>

</div>